export const REDUCER_NAME = 'basis'




// WEBPACK FOOTER //
// ./src/modules/analytics/state/basis/const.js